import {createFileRoute} from '@tanstack/react-router';

import {EditAdvanceRequestPage} from '@/modules/advance-requests/pages/EditAdvanceRequestPage';

const RouteComponent = () => {
  const {advanceId} = Route.useParams();
  return <EditAdvanceRequestPage advanceId={advanceId} />;
};

export const Route = createFileRoute('/_authenticated/advances/$advanceId_/edit')({
  component: RouteComponent,
});
